import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import styles from 'src/styles/common.module.scss'

export const TextHeaderEn = () => {
    return (
        <HighlightedText
            text="CLAIM YOUR BONUS"
            highlights={[{ word: 'YOUR BONUS' }]}
            className={styles.text_header}
        />
    )
}

export const TextContentEn = () => {
    return (
        <HighlightedText
            text="325% Bonus + 400 FREESPINS"
            highlights={[{ word: '325%' }, { word: '+ 400' }]}
            breakAfterWords={['Bonus']}
            className={styles['text_content--FOURTH']}
        />
    )
}
